import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchAnalysisItemDetail } from '@services/analysisItems';

export function useAnalysisItemDetail(studyId, itemId) {
  return useQuery({
    queryKey: ['analysisDetail', studyId, itemId],
    queryFn: () => fetchAnalysisItemDetail(studyId, itemId),
    enabled: Boolean(studyId && itemId),
  });
}

export function useAnalysisItemDetails() {
  return useMutation({
    mutationFn: ({ studyId, itemId }) => fetchAnalysisItemDetail(studyId, itemId),
  });
}
